/* RESPONSIBLE TEAM: team-reporting */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import type ManageSchedulesApi from 'embercom/lib/reporting/manage-schedules-api';

export default class ManageSchedulesController extends Controller {
  queryParams = ['reportId'];

  @tracked reportId: string | null = null;
  declare model: ManageSchedulesApi;
}
